import { properties } from "../properties";
import { resolveAdAttribution } from "./Attribution";

/**
 * Every call here is a BARE fetch with no Authorization header, same as
 * fetchPublicFeatureFlags: the backend JWT filter 403s on an *expired* Bearer
 * token even on permit-all endpoints, and request()'s refresh path can
 * hard-redirect to "/" — either would break the ad landing page for a
 * returning visitor with a stale token in localStorage.
 */
async function publicGet(endpoint) {
    const response = await fetch(properties.host + endpoint);
    if (!response.ok) throw new Error(`Request failed: ${response.status}`);
    return response.json();
}

export const fetchTutorialManuscript = () => publicGet("/sample/manuscript");
export const fetchTutorialAnalysis = () => publicGet("/sample/analysis");
export const fetchTutorialDeepThinkers = () => publicGet("/sample/deepthinkers");
export const fetchTutorialTopSimilarPapers = () => publicGet("/sample/similar/top/papers");

export async function downloadTutorialReport() {
    const response = await fetch(properties.host + "/sample/export/download");
    if (!response.ok) throw new Error(`Request failed: ${response.status}`);
    const blob = await response.blob();
    const disposition = response.headers.get("Content-Disposition");
    return { blob, disposition };
}

/**
 * Fire-and-forget attribution beacon (same bare-fetch rules as above; errors
 * swallowed so tracking can never break the page). Deduped per browser session
 * so Next/Back navigation and refreshes don't inflate the counts.
 */
export function trackAdVisit(page, searchParams) {
    const guard = "ftAdVisitTracked:" + page;
    try {
        if (sessionStorage.getItem(guard)) return;
        sessionStorage.setItem(guard, "1");
    } catch {
        // sessionStorage unavailable (private mode etc.) — still track the visit
    }
    const payload = { ...resolveAdAttribution(searchParams), page };
    // A visit the backend didn't record (deploy blip, rate limit) clears the
    // guard so the next in-session landing retries instead of losing the click.
    const clearGuard = () => { try { sessionStorage.removeItem(guard); } catch {} };
    fetch(properties.host + "/activity/visit", {
        method: "POST",
        headers: { "Content-Type": "application/json;charset=UTF-8" },
        body: JSON.stringify(payload),
        keepalive: true,
    })
        .then(res => (res.ok ? res.json() : { tracked: false }))
        .then(res => { if (!res?.tracked) clearGuard(); })
        .catch(clearGuard);
}
